import AppButton from "@/components/AppButton.vue";
import EmptyState from "@/components/EmptyState.vue";
import HeaderRelease from "@/components/HeaderRelease.vue";
import ThreeOptionsListGeneral from "@/components/ThreeOptionsListGeneral.vue";
import Request from "@/ts/Request";
import { Component, Vue } from "vue-property-decorator";
import Slick from "vue-slick";

@Component({
  components: {
    HeaderRelease,
    Slick,
    AppButton,
    ThreeOptionsListGeneral,
    EmptyState,
  },
})
export default class SupportRequest extends Vue {
  supportRequests: any = [];
  hasNoSupportRequest = false;
  cameFromConfirmCode = JSON.parse(
    sessionStorage.getItem("CAME_FROM_CONFIRM_CODE") || "false"
  );

  mounted() {
    this.getSupportRequestsByUser();
  }

  goBack() {
    if (this.cameFromConfirmCode) {
      sessionStorage.setItem("CAME_FROM_CONFIRM_CODE", "false");
      this.$router.go(-2);
    } else {
      this.$router.go(-1);
    }
  }

  getSupportRequestsByUser() {
    try {
      const self = this;
      const req = new Request();
      req.body = {
        USER_ID: sessionStorage.getItem("USER_ID"),
        TOKEN: sessionStorage.getItem("TOKEN"),
        NRORG: sessionStorage.getItem("NRORG"),
      };
      req.route = "getSupportRequestsByUser";
      req.callbackSuccess = function (response: any) {
        self.supportRequests = response.response.supportRequests;
        if (!self.supportRequests[0]) {
          self.hasNoSupportRequest = true;
        }
      };
      req.callbackError = function (error: any) {
        // self.mostraModal('Ocorreu um erro inesperado co enviar a solicitação!', 'done');
      };
      req.blockTouchEvents = false;
      req.send();
    } catch (e) {
      console.log(e);
      const mensagem =
        "Ocorreu um erro desconhecido. Por favor, tente de novo mais tarde";
      // this.mostraModal(mensagem);
    }
  }

  goSupportRequestDetails(supportRequest: any) {
    sessionStorage.setItem("SUPPORT_REQUEST", JSON.stringify(supportRequest));
    this.$router.push("SupportRequestDetails");
  }

  goNewSupportRequest() {
    this.$router.push("AddSupportRequest");
  }
}
